import { ShopifyEvents } from '../types/shopify'

export const SHOPIFY_EVENTS: { [key in ShopifyEvents]: string } = {
  SECTION_LOAD: 'shopify:section:load',
  SECTION_UNLOAD: 'shopify:section:unload',
  SECTION_SELECT: 'shopify:section:select',
  SECTION_DESELECT: 'shopify:section:deselect',
  SECTION_REORDER: 'shopify:section:reorder',
  BLOCK_SELECT: 'shopify:block:select',
  BLOCK_DESELECT: 'shopify:block:deselect',
}

export const KEY_CONSTS = {
  ARROW_LEFT_STRING_KEY: 'ArrowLeft',
  ARROW_RIGHT_STRING_KEY: 'ArrowRight',
  ARROW_LEFT_NUMBER_KEY: 37,
  ARROW_RIGHT_NUMBER_KEY: 39,
  ENTER_STRING_KEY: 'Enter',
  ENTER_NUMBER_KEY: 13,
  ESCAPE_STRING_KEY: 'Escape',
  ESCAPE_NUMBER_KEY: 27,
  SPACE_STRING_KEY: ' ',
  SPACE_NUMBER_KEY: 32,
  TAB_STRING_KEY: 'Tab',
  TAB_NUMBER_KEY: 9,
}
